export default "__VITE_ASSET__DiyflZtR__"